export class FunctionSuggestions {
    constructor() {
        this.content = "";
        this.context = "";
        this.edge_descriptions = {};
        this.functions = [];
    }
}
